let guard = null
let approved = false
let onPending = null
export function registerEditorGuard(callback, pending = null) {
	guard = callback
	onPending = pending
	approved = false
	return () => {
		if (guard === callback) {
			guard = null
			onPending = null
			approved = false
		}
	}
}
export async function confirmEditorNavigation() {
	if (approved) return false
	const currentGuard = guard
	const allowed = currentGuard ? await currentGuard() : true
	if (!allowed || approved || currentGuard !== guard) return false
	approved = true
	if (onPending) onPending(true)
	return true
}
export function isEditorNavigationApproved() {
	return approved
}
export function resetEditorNavigation() {
	approved = false
	if (onPending) onPending(false)
}
